export default __webpack_public_path__ + "static/media/flag-ptpra-ptpre.82be8367.png";